import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = (): null => {
    const { pathname } = useLocation();

    useEffect(() => {
        if (window.location.hash) return;
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export default ScrollToTop;
